// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"Modal-CloseButton-module--close-button--SNySU"};